export default __webpack_public_path__ + "static/now-couriers-nz-logo-c99a881e9c973f5d4c5503e0a33cf33f.png";